import type { AppStore } from "@/store/AppStore";
import { AiToolkitCalendarEventNotFoundError } from "@/modules/ai-toolkit/errors";
import type {
  GetCalendarEventInput,
  GetCalendarEventOutput,
} from "@mem-client/ai-toolkit/contract";
import {
  AiToolkitToolName,
  getCalendarEventInputSchema,
  getCalendarEventOutputSchema,
} from "@mem-client/ai-toolkit/contract";
import type { AiToolkitToolDefinition } from "@/modules/ai-toolkit/tools/types";
import { buildCalendarEvent } from "@/modules/ai-toolkit/tools/calendar/calendar-tools.helpers";

export const getCalendarEvent = async ({
  store,
  input,
}: {
  store: AppStore;
  input: GetCalendarEventInput;
}): Promise<GetCalendarEventOutput> => {
  const event = await store.spaceAccountCalendarEvents.getAsync(input.calendarEventId);

  if (!event) {
    throw new AiToolkitCalendarEventNotFoundError({
      calendarEventId: input.calendarEventId,
    });
  }

  return {
    calendarEvent: buildCalendarEvent({ event }),
  };
};

export const getCalendarEventTool: AiToolkitToolDefinition<
  AiToolkitToolName.GetCalendarEvent,
  GetCalendarEventInput,
  GetCalendarEventOutput
> = {
  name: AiToolkitToolName.GetCalendarEvent,
  inputSchema: getCalendarEventInputSchema,
  outputSchema: getCalendarEventOutputSchema,
  strict: true,
  execute: getCalendarEvent,
};
